var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "vue-admin" }, [
    _vm._m(0),
    _vm._v(" "),
    _c("div", { staticClass: "page-space" }, [
      _c(
        "div",
        { staticClass: "ui secondary segment" },
        [
          _vm.error
            ? _c("error-display", { attrs: { error: _vm.error } })
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            [
              _c(
                "router-link",
                {
                  staticClass: "ui small green button",
                  attrs: { to: "/admin/media/create" }
                },
                [
                  _c("i", { staticClass: "plus icon" }),
                  _vm._v(" Create Media/Resources\n                ")
                ]
              )
            ],
            1
          ),
          _vm._v(" "),
          _c("table", { staticClass: "ui small table segment" }, [
            _vm._m(1),
            _vm._v(" "),
            _c(
              "tbody",
              _vm._l(_vm.models, function(model) {
                return _c("tr", { key: model.id }, [
                  _c(
                    "td",
                    [
                      _c(
                        "router-link",
                        {
                          staticClass: "ui mini button",
                          attrs: { to: "/admin/media/" + model.id + "/edit" }
                        },
                        [_vm._v("Edit")]
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("td", [_vm._v(_vm._s(model.title))]),
                  _vm._v(" "),
                  _c("td", [_vm._v(_vm._s(model.type))]),
                  _vm._v(" "),
                  _c("td", [_vm._v(_vm._s(_vm.ShortDate(model.date)))]),
                  _vm._v(" "),
                  _c("td", [_vm._v(_vm._s(model.link || "Post"))]),
                  _vm._v(" "),
                  _c("td", [
                    _c("img", {
                      staticClass: "img-in-list",
                      attrs: {
                        alt: "default",
                        src: model.photo
                          ? model.photo.folder + model.photo.file
                          : "/img/default.jpg?v=1"
                      }
                    })
                  ])
                ])
              })
            )
          ])
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "header-banner" }, [
      _c("h1", [_vm._v("Media & Resources — Admin")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", [
      _c("tr", [
        _c("th"),
        _vm._v(" "),
        _c("th", [_vm._v("Title")]),
        _vm._v(" "),
        _c("th", [_vm._v("Type")]),
        _vm._v(" "),
        _c("th", [_vm._v("Date")]),
        _vm._v(" "),
        _c("th", [_vm._v("Link")]),
        _vm._v(" "),
        _c("th", [_vm._v("Photo")])
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-677597f8", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-677597f8","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/admin/media-resources/index.vue
// module id = 527
// module chunks = 0